/**
 The default color scheme.
 **/
const colorScheme = [
  '#4e79a7',
  '#76b7b2',
  '#edc949',
  '#af7aa1',
  '#9c755f',
  '#ff9da7',
  '#dd9900',
  '#dd33ff',
  '#33dd55',
  '#0066ff',
  '#bb7700',
  '#6655dd',
  '#00eeaa',
  '#ff4444',
  '#94aeca',
  '#acd3d0',
  '#f4de91',
  '#c7a1bd',
  '#b99e8f',
  '#ffc4ca',
  '#00c4ca',
  '#ff00ca',
  '#ffa400',
  '#cac4ca',
  '#ff8080',
  '#268cff',
  '#ffb77d',
  '#6bff8c',
  '#3fffd3',
  '#fbf6ff',
  '#ff2eea',
  '#ff7075',
  '#4f91ff',
  '#3fff59',
  '#ff5eb5',
];

export default colorScheme;
